import { Stack } from '@mui/system';
import React from 'react';
import { labelStyle, stackStyle, Text2 } from '../../containers/OrderTracking';
import {
	adminAreas,
	columnStyle,
	compareQuantities,
	generateBlob,
	getDivisonCodeByDivisionName,
	getFullName,
	handleConfirmModal,
	handleError,
	handleSuccess,
	handleWarning,
	money,
	rowStyle,
	whichEnvURL,
	whichStatus,
	whichTypeOfClient,
} from '../../helpers/utils';
import { Document, Page, pdfjs } from 'react-pdf';
import { LinearWithValueLabel } from '../orders/ProgressBar';
import Label from '../utils/Label';
import {
	Badge,
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Menu,
	MenuItem,
	Tooltip,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';
import AddCommentIcon from '@mui/icons-material/AddComment';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import ListIcon from '@mui/icons-material/List';
import DescriptionIcon from '@mui/icons-material/Description';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import RateReviewIcon from '@mui/icons-material/RateReview';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import ContactsIcon from '@mui/icons-material/Contacts';
import ThreePIcon from '@mui/icons-material/ThreeP';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { diffDays, formatDateTimeMX, getTodayDateMoment } from '../../helpers/hours';
import { useNavigate } from 'react-router-dom';
import { OrderInfo } from './DialogBiasInfo/OrderInfo';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { generateReport } from '../../actions/pdf';
import {
	convertQuotationToOrder,
	updateOrderStatus,
	updateStats
} from '../../actions/orders';
import { confirmModal } from '../../helpers/sweetAlert2';
import { AnnotationForm } from './DialogBiasInfo/AnnotationForm';
import { OrderRepo } from './DialogBiasInfo/OrderRepo';
import { ContactForm } from './DialogBiasInfo/ContactForm';
import { updateDeliveryForecast } from '../../actions/biases';
import { sendWhatsApp, template5 } from '../../helpers/whatsappApi';
import { createWorkspace } from '../../actions/files';
import { getAllStaffAndAdminContacts } from '../../actions/user';
import { sendEmail } from '../../helpers/emailAPI';
import { getDataByUrl } from '../../actions/catalogs';
import { OrderIncidence } from './DialogBiasInfo/OrderIncidence';
import { updateNotification } from '../../actions/notifications';
import { updateAnnotationOrder } from '../../actions/orderAnnotation';
import { getAnnotationCounter } from '../../actions/annotation';

export const IconButtonColor = {
	color: '#143f6c',
	width: '30px',
	height: '30px',
	margin: 0,
};

export const JustIconStyle = {
	color: '#143f6c',
	margin: '0 10px 0 0',
};

export const OrderHeader = ({
	order = null,
	refreshOrder = null,
	totalAmount,
}) => {
	// Navigation
	const navigate = useNavigate();

	// Store: user
	const { user = null } = useSelector((state) => state);
	// Store: areas
	const { area: areas } = useSelector((state) => state.catalogs);

	// Reject validation
	const [reject, setReject] = useState(false);

	// Annotations to check - counter
	const [annotationsToCheckCounter, setAnnotationsToCheckCounter] = useState(
		getAnnotationCounter(order?.annotations)
	);

	// Is Form going to be used?
	const [newContact, setNewContact] = useState(false);

	// Full-screen dialog
	const [open, setOpen] = useState(false);
	const handleClickOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	// Full-screen dialog repository
	const [openRepo, setOpenRepo] = useState(false);
	const handleClickOpenRepo = () => setOpenRepo(true);
	const handleCloseRepo = () => setOpenRepo(false);

	// Annotation dialog
	const [open2, setOpen2] = useState(false);
	const handleClickOpen2 = () => setOpen2(true);
	const handleClose2 = () => setOpen2(false);

	// Contact dialog
	const [openContactDialog, setOpenContactDialog] = useState(false);
	const handleClickOpenContactDialog = () => setOpenContactDialog(true);
	const handleCloseContactDialog = (_, reason) => {
		if (reason && reason == 'backdropClick') return;
		setOpenContactDialog(false);
	};

	// Full-screen dialog
	const [openIncidence, setOpenIncidence] = useState(false);
	const handleClickOpenIncidence = () => setOpenIncidence(true);
	const handleCloseIncidence = () => setOpenIncidence(false);

	// PDF viewer dialog
	const [isOpenPDFViewer, setIsOpenPDFViewer] = useState(false);
	const [currentBlob, setCurrentBlob] = useState(null);
	const [numPages, setNumPages] = useState(null);
	const [scale, setScale] = useState(1.3); // State for zoom level

	// Handle close PDF
	const handleClosePDFDialog = () => setIsOpenPDFViewer(false);

	// Set worker URL for PDF.js
	pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

	const handleGeneratePDF_test_viewer = (withAmount = false) => {
		generateReport(order, withAmount)
			.then(async (response) => {
				const blobRes = await generateBlob(response);
				setCurrentBlob(blobRes);
				setIsOpenPDFViewer(true);
			})
			.catch((error) =>
				handleError(
					error,
					'Ocurrió un error al intentar generar el reporte'
				)
			);
	};

	// Menu
	const [openMenu, setOpenMenu] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);
	const handleClickMenu = (event) => {
		setAnchorEl(event.currentTarget);
		setOpenMenu(true);
	};

	// Menu
	const [openMenuContact, setOpenMenuContact] = useState(false);
	const [anchorElContact, setAnchorElContact] = useState(null);
	const handleClickMenuContact = (event) => {
		setAnchorElContact(event.currentTarget);
		setOpenMenuContact(true);
	};

	// Menu PDF
	const [openMenu2, setOpenMenu2] = useState(false);
	const [anchorEl2, setAnchorEl2] = useState(null);
	const handleClickOpen3 = (event) => {
		setAnchorEl2(event.currentTarget);
		setOpenMenu2(true);
	};

	const handleCloseMenuContact = () => {
		setAnchorElContact(null);
		setOpenMenuContact(false);
	};

	const handleCloseMenu = () => {
		setAnchorEl(null);
		setOpenMenu(false);
	};

	const handleCloseMenu2 = () => {
		setAnchorEl2(null);
		setOpenMenu2(false);
	};

	// Check if the amounts match
	const checkAmountMatch = () =>
		compareQuantities(order?.amount?.number, totalAmount);

	// Annotation option
	const [annotationOption, setAnnotationOption] = useState('');

	const handleSendWhatsAppMessage = async (
		newStatus,
		finalStatus,
		newNumberOrder = false
	) => {
		if (order.contacts.length > 0) {
			let contactList = order.contacts;

			// Send message to all operations staff and admins
			// if the status is Authorization
			if (newStatus === 'AUT') {
				contactList = (await getAllStaffAndAdminContacts()).data;
			}

			// Send WhatsApp
			sendWhatsApp(
				order,
				user,
				contactList,
				template5(
					getFullName(user),
					newStatus === 'VAL'
						? user?.user_type?.id === 2
							? 'Administrativa'
							: 'Ventas'
						: user?.user_type?.id === 2
							? 'Administrativa'
							: user?.area?.name,
					finalStatus,
					newNumberOrder ? newNumberOrder : order.number_order
				)
			).then(({ data }) => {
				if (data?.ok || data?.msg.includes('sent')) {
					handleSuccess('Mensaje enviado');
				} else {
					handleError(
						data?.msg,
						'Ocurrió un error al intentar enviar el mensaje. Intenta más tarde'
					);
				}
			});
		} else {
			handleWarning('La lista de contactos está vacía');
		}
	};

	const handleUpdateStatus = (newStatus, wasRejected = false) => {
		updateOrderStatus(order?.original_order, newStatus, wasRejected)
			.then(() => {
				// Feedback
				handleSuccess('Orden actualizada correctamente');
			})
			.catch((error) => {
				handleError(
					error,
					'Ocurrió un error al intentar actualizar el pedido'
				);
			})
			.finally(() => {
				refreshOrder();
				setReject(false);
			});
	};

	const handleUpdateDeliveryForecastDays = () => {
		const addedDays =
			diffDays(order?.entry_date, order?.delivery_date) || 30;

		const today = getTodayDateMoment();
		updateDeliveryForecast(order.id, getTodayDateMoment(addedDays), today)
			.then(({ data }) => {
				if (!data.ok) {
					handleError(
						data.error,
						'Ocurrió un error al intentar actualizar las fechas de inicio de las subpartidas'
					);
				}
			})
			.catch((error) => {
				handleError(
					error,
					'Ocurrió un error al intentar actualizar las fechas de inicio de las subpartidas'
				);
			})
			.finally(() => {
				refreshOrder();
				setReject(false);
			});
	};

	const getLabelHandleStatusOrder = (action) => {
		if (order?.was_a_quotation && order?.number_order.includes('COT')) {
			return `¿Seguro que deseas convertir la cotización a una orden?`;
		} else {
			return `¿Seguro que deseas ${action} el pedido?`;
		}
	};

	const getButtonLabelModalStatusOrder = (action) => {
		return `Sí, ${
			order?.was_a_quotation && order?.number_order.includes('COT')
				? 'convertir'
				: action
		}`;
	};

	const handleSendEmailAuthorizationOrder = async (orderData) => {
		let template = 'pilu-autorization-order';

		if (orderData?.division === 'TAB') {
			template = 'saro-autorization-order';
		}

		const division =
			order?.division?.length > 0 && order?.division?.length <= 3
				? order?.division
				: getDivisonCodeByDivisionName(order?.division);

		const { data: filteredUsers } = await getDataByUrl(
			`/api/auth/users?user_type__id__lt=5&division=${division}`
		);

		let emails = filteredUsers.results?.map(({ email }) => email) || [];

		// Add current user if it doesn't exists in the array
		if (!emails.includes(user?.email)) {
			emails.push(user?.email);
		}

		// Send email if array is not empty
		if (emails.length) {
			sendEmail(
				emails,
				{
					numberOrder: order?.number_order,
					clientName: order?.client_id?.company_name,
					linkOrder: whichEnvURL(),
				},
				template
			)
				.then(({ data }) => {
					if (data?.ok) {
						handleSuccess('Correo enviado');
					} else {
						handleWarning(
							'No se pudo enviar el correo, consulte a soporte'
						);
					}
				})
				.catch((error) => {
					handleError(
						error,
						'Ocurrió un error al intentar mandar el correo, consulte a soporte'
					);
				});
		}
	};

	const handleSetStatusOrder = (action, statusCode) => {
		if (checkAmountMatch()) {
			confirmModal(
				'warning',
				'Precaución',
				getLabelHandleStatusOrder(action),
				getButtonLabelModalStatusOrder(action)
			)
				.then(async ({ isConfirmed }) => {
					if (isConfirmed) {
						// Final status
						let finalStatus =
							statusCode === 'ICF'
								? 'rechazado'
								: whichStatus(statusCode).toLowerCase();
						let newNumberOrder = false;

						// Autorize
						if (statusCode === 'AUT') {
							// Update delivery forecast days and set status
							handleUpdateDeliveryForecastDays();

							// Send email
							// TODO: DISCOMMENT THIS WHEN THE PAYMENT IS READY
							// handleSendEmailAuthorizationOrder(order);
						}
						// Validate and it was a quotation
						else if (
							statusCode === 'VAL' &&
							order?.was_a_quotation
						) {
							// Convert a quotation to an order and set status
							const { data } = await convertQuotationToOrder(
								order?.id
							);

							if (data?.ok) {
								// Set fields
								finalStatus = `convertido la cotización ${order?.number_order} a`;
								newNumberOrder = data?.new_number_order;
								// Create workspace
								createWorkspace(
									{
										number_order: data?.new_number_order,
									},
									user
								);
								refreshOrder();
							} else {
								handleError(
									data?.error,
									'Error al intentar convertir la cotización a pedido'
								);
							}
						}
						// Reject, validation, release
						else {
							if (statusCode === 'VAL' && order?.rejected) {
								if (order?.annotations?.length > 0) {
									// Get current-not-finished annotation
									const annotation = order?.annotations?.find(
										(ann) =>
											!ann.is_done &&
											ann.notification_id?.length > 0
									);

									// Get notification firestore id
									const notificationAnnotationId =
										annotation?.notification_id;

									if (notificationAnnotationId?.length > 0) {
										// Update notification order (Firebase/Firestore)
										updateNotification(
											notificationAnnotationId,
											false, // It has to be false, I don't know why but the function is the opposite (?)
											user
										);
									}

									/*
									tengo que actualizar el badge con el número de notificaciones que hay para las annotation
									*/

									// Update annotation order (DB)
									updateAnnotationOrder(annotation.id, {
										...annotation,
										is_done: true,
									})
										.then(({ data: updatedAnnotation }) => {
											const newAnnotations =
												order?.annotations?.map(
													(item) => {
														if (
															item.id ===
															updatedAnnotation.id
														) {
															return updatedAnnotation;
														}
														return item;
													}
												);
											refreshOrder();
											setAnnotationsToCheckCounter(
												getAnnotationCounter(
													newAnnotations
												)
											);
										})
										.catch((error) => handleError(error));
								}
							}
							handleUpdateStatus(statusCode, reject);
						}

						// Send WhatsApp message
						handleSendWhatsAppMessage(
							statusCode,
							finalStatus,
							newNumberOrder
						);

						// Update latest statistics
						updateStats().catch((error) => console.log(error));
					}
				})
				.catch((error) =>
					handleError(
						error,
						`Error al mostrar la ventana para ${action}`
					)
				);
		} else {
			handleConfirmModal(
				'Precaución',
				`El importe de la orden (${
					order?.amount?.formatted
				}) no coincide con la suma de los importes de las partidas (${money(
					totalAmount
				)}). Consulte al jefe de área.`,
				'warning',
				'OK',
				false
			);
		}
	};

	const handleClickItemMenu = (type) => {
		handleClickOpen2();
		setAnnotationOption(type);
		handleCloseMenu();
	};

	const onDocumentLoadSuccess = ({ numPages }) => {
		setNumPages(numPages);
	};

	const handleDownload = () => {
		const url = URL.createObjectURL(currentBlob);
		const a = document.createElement('a');
		a.href = url;
		a.download = `${order.number_order}.pdf`;
		a.click();
	};

	const handleZoomIn = () => {
		setScale((prevScale) => prevScale + 0.1);
	};

	const handleZoomOut = () => {
		setScale((prevScale) => prevScale - 0.1);
	};

	const ButtonStyle = {
		marginLeft: '15px',
	};

	return (
		<Stack
			style={{
				...stackStyle,
				height: '100%',
				margin: 0,
				border: '1px solid white',
				justifyContent: 'space-between',
			}}
		>
			<Dialog
				open={isOpenPDFViewer}
				onClose={handleClosePDFDialog}
				maxWidth='md'
				fullWidth
			>
				<DialogTitle>Visualizador de PDF</DialogTitle>
				<DialogContent>
					<div className='pdf-controls'>
						<Button style={ButtonStyle} onClick={handleZoomIn}>
							Acercar Zoom
						</Button>
						<Button style={ButtonStyle} onClick={handleZoomOut}>
							Alejar Zoom
						</Button>
						<Button
							color='success'
							onClick={handleDownload}
							style={ButtonStyle}
						>
							Descargar
						</Button>
						<Button
							color='error'
							onClick={handleClosePDFDialog}
							style={ButtonStyle}
						>
							Salir
						</Button>
					</div>

					{currentBlob && (
						<Document
							file={currentBlob}
							onLoadSuccess={onDocumentLoadSuccess}
						>
							{[...Array(numPages)].map((_, index) => (
								<Page
									key={`page_${index + 1}`}
									pageNumber={index + 1}
									scale={scale}
								/>
							))}
						</Document>
					)}
				</DialogContent>
			</Dialog>
			<OrderInfo
				open={open}
				handleClose={handleClose}
				orderId={order?.id}
				areas={areas}
				order={order}
			/>
			<OrderRepo
				open={openRepo}
				handleClose={handleCloseRepo}
				numberOrder={order?.number_order}
			/>
			<AnnotationForm
				open={open2}
				refreshOrder={refreshOrder}
				handleClose={handleClose2}
				orderId={order?.id}
				order={order.original_order}
				annotationOption={annotationOption}
				handleUpdateStatus={handleUpdateStatus}
				reject={reject}
			/>
			<ContactForm
				open={openContactDialog}
				handleClose={handleCloseContactDialog}
				newContact={newContact}
				setNewContact={setNewContact}
				order={order.original_order}
				refreshOrder={refreshOrder}
			/>
			<OrderIncidence
				open={openIncidence}
				handleClose={handleCloseIncidence}
				orderId={order?.id}
				areas={areas}
				order={order}
			/>
			<div
				style={{
					...columnStyle,
					border: '1px solid white',
					width: '20%',
				}}
			>
				{/* Title */}
				<Text2
					title='No. de pedido'
					text={order?.number_order}
					var1='h6'
					var2='h4'
					bold
				/>
				{order?.order_parent?.length > 0 && (
					<Text2
						title={`Pedido padre: ${order?.order_parent}`}
						var1='h6'
						var2='p'
					/>
				)}

				{/* Progress */}
				<LinearWithValueLabel progress={order?.progress} />

				{/* Status */}
				<Label color={order?.status.color} sx={labelStyle}>
					{order?.status.name}
				</Label>

				{/* Actions */}
				<div style={{ display: 'flex', flexDirection: 'row' }}>
					{/* Info button */}
					<Tooltip title='Más información'>
						<IconButton
							style={IconButtonColor}
							aria-label='profile'
							color='primary'
							onClick={handleClickOpen}
						>
							<InfoIcon />
						</IconButton>
					</Tooltip>

					{/* Repository */}
					<Tooltip title='Almacén digital'>
						<IconButton
							style={IconButtonColor}
							aria-label='profile'
							color='primary'
							onClick={handleClickOpenRepo}
						>
							<CloudDoneIcon />
						</IconButton>
					</Tooltip>

					{/* Contacts */}
					<div>
						<IconButton
							style={IconButtonColor}
							aria-label='profile'
							color='primary'
							onClick={handleClickMenuContact}
						>
							<PeopleAltIcon />
						</IconButton>
						<Menu
							id='basic-menu'
							anchorEl={anchorElContact}
							open={openMenuContact}
							onClose={handleCloseMenuContact}
							MenuListProps={{
								'aria-labelledby': 'basic-button',
							}}
						>
							<MenuItem
								onClick={() => {
									handleClickOpenContactDialog();
									setNewContact(true);
								}}
							>
								<ThreePIcon style={JustIconStyle} /> Agregar
								contacto
							</MenuItem>
							<MenuItem
								onClick={() => {
									handleClickOpenContactDialog();
									setNewContact(false);
								}}
							>
								<ContactsIcon style={JustIconStyle} /> Ver lista
								de contactos
							</MenuItem>
						</Menu>
					</div>

					{/* Edit button */}
					{/* Mesa de control or Asesor */}
					{(user?.area?.id === 1 ||
						[1, 2, 3, 5].includes(user?.user_type?.id)) && (
						<Tooltip title='Editar'>
							<IconButton
								style={IconButtonColor}
								aria-label='edit'
								color='primary'
								onClick={() => {
									const path = `/dashboard/editar-orden/${order?.id}`;
									localStorage.setItem(
										'currentPathPilu',
										path
									);
									navigate(path);
								}}
							>
								<EditIcon />
							</IconButton>
						</Tooltip>
					)}

					{/* Annotation button */}
					{/* <Tooltip title='Nueva anotación' placement='top-start'> */}
					<div>
						<Badge
							badgeContent={annotationsToCheckCounter}
							color='primary'
						>
							<IconButton
								style={IconButtonColor}
								aria-label='profile'
								color='primary'
								onClick={handleClickMenu}
							>
								<SpeakerNotesIcon />
							</IconButton>
							<Menu
								id='basic-menu'
								anchorEl={anchorEl}
								open={openMenu}
								onClose={handleCloseMenu}
								MenuListProps={{
									'aria-labelledby': 'basic-button',
								}}
							>
								<MenuItem
									onClick={() => handleClickItemMenu('new')}
								>
									<AddCommentIcon style={JustIconStyle} />{' '}
									Nueva anotación
								</MenuItem>
								<MenuItem
									onClick={() =>
										handleClickItemMenu('problem')
									}
								>
									<ReportProblemIcon style={JustIconStyle} />{' '}
									Reportar problema
								</MenuItem>
								<MenuItem
									onClick={() => handleClickItemMenu('list')}
								>
									<ListIcon style={JustIconStyle} /> Ver
									anotaciones{' '}
									{annotationsToCheckCounter > 0
										? `(${annotationsToCheckCounter})`
										: ''}
								</MenuItem>
							</Menu>
						</Badge>
					</div>
					{/* </Tooltip> */}

					{/* Generate PDF button */}
					{/* {order?.released && ( */}
					<div>
						<IconButton
							style={IconButtonColor}
							aria-label='profile'
							color='primary'
							onClick={handleClickOpen3}
						>
							<PictureAsPdfIcon />
						</IconButton>
						<Menu
							id='basic-menu'
							anchorEl={anchorEl2}
							open={openMenu2}
							onClose={handleCloseMenu2}
							MenuListProps={{
								'aria-labelledby': 'basic-button',
							}}
						>
							<MenuItem
								onClick={() => handleGeneratePDF_test_viewer()}
							>
								<DescriptionIcon style={JustIconStyle} />{' '}
								Generar reporte
							</MenuItem>
							{/* Superadmin and admin */}
							{([1, 2, 3, 5].includes(user?.user_type?.id) ||
								adminAreas.includes(user?.area?.name)) && (
								<MenuItem
									onClick={() =>
										handleGeneratePDF_test_viewer(true)
									}
								>
									<RequestQuoteIcon style={JustIconStyle} />{' '}
									Generar reporte con importes
								</MenuItem>
							)}
						</Menu>
					</div>
					{/* )} */}

					{/* New bias button */}
					{/* Mesa de control or Asesor */}
					{(user?.area?.id === 1 ||
						[1, 2, 3, 5].includes(user?.user_type?.id)) && (
						<>
							<Tooltip title='Nueva partida'>
								<IconButton
									style={IconButtonColor}
									aria-label='profile'
									color='primary'
									onClick={() => {
										const path = `/dashboard/order/${order?.id}/new-bias`;
										localStorage.setItem(
											'currentPathPilu',
											path
										);
										navigate(path);
									}}
								>
									<CheckroomIcon />
								</IconButton>
							</Tooltip>
							{order?.order_parent?.length === 0 && (
								<Tooltip title='Nueva incidencia'>
									<IconButton
										style={IconButtonColor}
										aria-label='profile'
										color='primary'
										onClick={() => {
											handleClickOpenIncidence();
										}}
									>
										<RateReviewIcon />
									</IconButton>
								</Tooltip>
							)}
						</>
					)}
				</div>

				{/* VALIDATIONS AND RELEASES */}

				{/* Anyone who is not a operator validates the order unless the order was created by "Mesa de Control" */}
				{(user?.id === 1 ||
					user?.user_type?.name !== 'Operador' ||
					order?.created_by?.area?.name === 'Mesa de Control') &&
					order?.status?.key === 'ICF' && (
						<div>
							<Button
								style={{ margin: '15px 0 0 0' }}
								variant='contained'
								fullWidth
								disabled={order?.status.key !== 'ICF'}
								color='primary'
								onClick={() => {
									if (order?.amount?.number > 0) {
										handleSetStatusOrder('validar', 'VAL');
									} else {
										handleWarning(
											'No puedes convertir a pedido si el importe es $0'
										);
									}
								}}
							>
								{order?.was_a_quotation
									? 'Convertir a pedido'
									: 'Validar'}
							</Button>
						</div>
					)}

				{/* Mesa de control authorize the order */}
				{(user?.id === 1 ||
					user?.area?.id === 1 ||
					user?.email === 'flopezramirez@hotmail.com') &&
					order?.status.key === 'VAL' && (
						<div
							style={{ display: 'flex', flexDirection: 'column' }}
						>
							<Button
								style={{ margin: '15px 0 0 0' }}
								variant='contained'
								fullWidth
								disabled={order?.status.key !== 'VAL'}
								color='primary'
								onClick={() =>
									handleSetStatusOrder('autorizar', 'AUT')
								}
							>
								Autorizar
							</Button>
							<Button
								style={{ margin: '15px 0 0 0' }}
								variant='contained'
								fullWidth
								disabled={order?.status.key !== 'VAL'}
								color='error'
								onClick={() => {
									handleConfirmModal(
										'Rechazar validación',
										'Para rechazar una validación reporta el problema',
										'warning',
										'Reportar problema'
									).then(({ isConfirmed }) => {
										if (isConfirmed) {
											setAnnotationOption('rejection');
											setReject(true);
											handleClickOpen2();
										}
									});
								}}
							>
								Rechazar validación
							</Button>
						</div>
					)}

				{/* Logistics releases the order */}
				{user?.id === 1 ||
					(user?.area?.id === 3 && order?.status.key === 'AUT' && (
						<div>
							<Button
								style={{ margin: '15px 0 0 0' }}
								variant='contained'
								fullWidth
								disabled={order?.status.key !== 'AUT'}
								color='success'
								onClick={() =>
									handleSetStatusOrder('liberar', 'REL')
								}
							>
								Liberar
							</Button>
						</div>
					))}
			</div>

			{/* Content */}
			<div
				style={{
					...columnStyle,
					border: '1px solid white',
					width: '80%',
					justifyContent: 'space-evenly',
				}}
			>
				<div
					style={{
						...rowStyle,
						border: '1px solid white',
						width: '100%',
						justifyContent: 'space-evenly',
					}}
				>
					<Text2
						title={`Cliente - ${whichTypeOfClient(order?.type_of_client) ?? ''}`}
						text={order?.client_id.company_name}
						var2='h6'
					/>
				</div>
				<div
					style={{
						...rowStyle,
						border: '1px solid white',
						width: '100%',
						justifyContent: 'space-evenly',
					}}
				>
					<Text2
						title='Fecha de orden'
						text={order?.entry_date}
						var2='h6'
					/>
					<Text2
						title='Fecha de entrega'
						text={order?.delivery_date}
						var2='h6'
					/>
					<Text2
						title='Fecha estimada'
						text={order?.delivery_forecast}
						color={
							order?.status.color === 'error' &&
							!(order?.delivery_date === order?.delivery_forecast)
								? 'red'
								: 'black'
						}
						var2='h6'
					/>
					<Text2
						title='Tiempo de entrega'
						text={`${order?.diff_days} días`}
						var2='h6'
					/>

					<Text2
						title='Tipo de empaque'
						text={order?.type_of_packing}
						var2='h6'
					/>
				</div>
				<div
					style={{
						...rowStyle,
						border: '1px solid white',
						width: '100%',
						justifyContent: 'space-evenly',
						margin: '15px 0 0 0',
					}}
				>
					<Text2
						title='Creado por'
						text={order?.created_by.fullname}
						var2='h6'
					/>
					<Text2 title='División' text={order?.division} var2='h6' />
					<Text2
						title='Importe (con IVA)'
						text={order?.amount?.formatted}
						var2='h6'
					/>
					<Text2
						title='Importe (sin IVA)'
						text={order?.amount?.withoutIVA}
						var2='h6'
					/>
					<Text2
						title='Fecha de creación'
						text={formatDateTimeMX(order?.created_at)}
						var2='h6'
					/>
				</div>
			</div>
		</Stack>
	);
};
